import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let backgroundColor = props.disabled ? colors.darkBlue_lighter : colors.green_lighter;

  let color = props.disabled ? colors.darkBlue_light : '#43CBBB';

  return (
    <svg width="70" height="70" fill="none" viewBox="0 0 70 70">
      <rect width="70" height="70" fill={backgroundColor} rx="35"></rect>
      <path
        fill={color}
        d="M48.899 30.998v8.004l1.325-1.325H39.55c-.715 0-1.325.606-1.325 1.325v10.673l1.325-1.325h-8.003l1.325 1.325v-3.61-5.752-1.311c0-.716-.606-1.325-1.325-1.325H20.874l1.325 1.325v-2.717-4.293-.994l-1.325 1.325h10.673c.716 0 1.325-.606 1.325-1.325v-3.61-5.751-1.312l-1.325 1.325h8.003l-1.325-1.325v10.673c0 .716.607 1.325 1.325 1.325h10.674c.692 0 1.358-.61 1.325-1.325-.033-.719-.583-1.325-1.325-1.325H39.55l1.326 1.325v-3.61-5.751-1.312c0-.715-.607-1.325-1.325-1.325h-8.004c-.715 0-1.325.606-1.325 1.325v10.673l1.325-1.325H20.874c-.716 0-1.325.607-1.325 1.325v8.004c0 .715.606 1.325 1.325 1.325h10.673l-1.325-1.325v10.673c0 .716.606 1.325 1.325 1.325h8.003c.716 0 1.326-.606 1.326-1.325v-3.61-5.752-1.311l-1.325 1.325h10.673c.715 0 1.325-.606 1.325-1.325v-2.717-4.293-.994c0-.692-.61-1.358-1.325-1.325-.72.03-1.325.58-1.325 1.325z"></path>
    </svg>
  );
}

export default Icon;
